module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAABSgAwAEAAAAAQAAACQAAAAAwXHw2gAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAALZJREFUSA3tlk0Kg0AMhaVnqfYYvYkXtvQUahHUrcvplzqFIHYxiRvpPHj+LPLxJolgEUKo8YwfuCq8ijBuH3VcfVAAkkzLB4VUYYFoZahjUDTyPD0tSXv49M8N7WWA5k+f4r3j/zl0oS13b08HIFr9xUxcC4OzPlLWibc6Gs+2I1Mo67OFyfrcktNmWO7Zj6XJq2Fajeth36bMBViDtV68pCf7DpniUdF8sJhQfokn/MT2ZDHhG1e2X+JnU0dkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/fanhui1.png
// module id = ojqY
// module chunks = 2